import { EnvironmentOutlined } from '@ant-design/icons';
import { PermissionName } from '../../../valueobject/permissionName';
import { BusinessTypeKeys } from '../../../constant';

/**
 * タブメニュー情報
 */
export type TabMenuItem = {
  key: string;
  label: string;
  icon: React.ReactNode;
  permission: PermissionName;
  allowedBusinessTypes?: BusinessTypeKeys[];
  readWrite?: boolean;
  reflesh?: boolean; // true の場合、navigateによる遷移時に再読み込みを行う
};

/**
 * タブメニュー一覧
 */
export const Menus: TabMenuItem[] = [
  {
    key: '/main',
    label: 'メイン',
    icon: <EnvironmentOutlined />,
    permission: PermissionName.DASHBOARD,
  },
  {
    key: '/schedule',
    label: 'スケジュール一覧',
    icon: <EnvironmentOutlined />,
    permission: PermissionName.SCHEDULE,
  },
  {
    key: '/notification',
    label: '通知一覧',
    icon: <EnvironmentOutlined />,
    permission: PermissionName.NOTIFICATION,
  },
  {
    key: '/task_list',
    label: '作業競合確認',
    icon: <EnvironmentOutlined />,
    permission: PermissionName.APPLICATION_LIST,
  },
  {
    key: '/issue',
    label: '臨時作業入力',
    icon: <EnvironmentOutlined />,
    permission: PermissionName.ISSUE,
    readWrite: true,
    reflesh: true,
  },
  {
    key: '/task_csvregist',
    label: '作業計画一括投入',
    icon: <EnvironmentOutlined />,
    permission: PermissionName.BULK_INSERT_PLAN,
    allowedBusinessTypes: [BusinessTypeKeys.cleaning, BusinessTypeKeys.greening],
  },
  {
    key: '/task_edit',
    label: '作業計画参照・更新',
    icon: <EnvironmentOutlined />,
    permission: PermissionName.WORK_PLAN,
  },
  {
    key: '/account_list',
    label: 'アカウント管理',
    icon: <EnvironmentOutlined />,
    permission: PermissionName.ACCOUNT_MANAGER,
  },
  {
    key: '/password_change',
    label: 'パスワード変更',
    icon: <EnvironmentOutlined />,
    permission: PermissionName.USER,
  },
];
